import {Text} from '@/components-v2/atoms'
import {Dropdown, TextInput} from '@/components-v2/molecules'
import {Constants} from '@/utils/constants/commonConstants'
import {ANY_ID} from '@/utils/constants/promotionConstants'

const INVALID_VALUE_MESSAGE = 'Value Invalid'

/** Single-select buy quantity dropdown (e.g. "Buy [2]"). */
export const QuantityDropdown = ({
  options,
  value,
  onChange,
  isLoading = false,
  isRequired = false,
  hasError = false,
  placeholder = ANY_ID,
  errorMessage = INVALID_VALUE_MESSAGE,
}) => (
  <Dropdown
    // Peacock sets an inline width (300px by default), so the width must go through its prop
    width="84px"
    childList={options ?? []}
    placeholder={placeholder}
    selectedValue={value}
    setSelectedValue={onChange}
    isClearable={false}
    selection={isLoading ? 'loading' : 'single'}
    isRequired={isRequired}
    error={hasError}
    helperText={hasError ? errorMessage : undefined}
    autoComplete="off"
  />
)

/** Currency-prefixed numeric input used on the amount tab (e.g. "Buy $ [100]"). */
export const AmountInput = ({currencyCode, value, onChange, hasError = false}) => (
  <>
    <Text>{currencyCode}</Text>
    <div className="w-[85px]">
      <TextInput
        type="number"
        value={value}
        placeholderText="0.0"
        onUpdate={onChange}
        error={hasError ? INVALID_VALUE_MESSAGE : undefined}
      />
    </div>
  </>
)

/** Multi-select products dropdown; the placeholder doubles as the summary of the selected items. */
export const ProductsDropdown = ({
  options,
  value,
  selectedText,
  onChange,
  isLoading = false,
  isRequired = false,
  disabled = false,
  hasError = false,
  errorMessage = INVALID_VALUE_MESSAGE,
  width,
}) => (
  <Dropdown
    childList={options ?? []}
    width={width}
    placeholder={selectedText || Constants.AddProducts}
    selectedValue={value}
    setSelectedValue={onChange}
    isClearable={true}
    selection={isLoading ? 'loading' : 'multiple'}
    isRequired={isRequired}
    disabled={disabled}
    error={hasError}
    helperText={hasError ? errorMessage : undefined}
    autoComplete="off"
  />
)
